import { annotationPlugin } from "@features/custom-annotations";

import { chartDataManagerPlugin } from "./chart-data-manager-plugin";
import { yScaleTitlesPlugin } from "./y-scale-titles-plugin";

export const plugins = [
  chartDataManagerPlugin,
  annotationPlugin,
  yScaleTitlesPlugin,
];
